import { route } from '../../helpers';
import { CheckoutStages } from '../../../constants/AppConstants';

module.exports = route(CheckoutStages.PAYMENT_AMAZON_PAY, {
    getComponent(location, cb) {
        require.ensure(
            []
            ,
            (require) => {
                cb(null, require('../../../components/checkout/PaymentAmazonPay').default);
            },
            () => {
                // Adding fallback to prevent blank pages when the chunk is not available (I.E: after a release).
                // TODO: use a smarter way to get an updated chunk
                window.location.reload();
            },
            'payment');
    },
});



// WEBPACK FOOTER //
// ./src/routes/Checkout/Payment/PaymentAmazonPay.js